var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgElectricite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 251,
    viewBox: "0 0 251 251",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M107.856 31.1996C89.1962 61.6496 70.5262 92.1094 51.8662 122.559L96.5962 148.79L93.9762 234.52C113.606 205.42 133.226 176.31 152.856 147.21C145.076 142.51 137.306 137.81 129.526 133.12C121.776 128.45 114.026 123.779 106.266 119.109C106.556 104.439 106.826 89.7696 107.096 75.0896C107.356 60.4596 107.616 45.8296 107.856 31.1996Z",
    fill: "#B2E8C5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M130.526 15.6796L107.856 31.1996L106.266 119.109C114.736 112.09 123.206 105.069 131.666 98.0494L130.526 15.6796Z",
    fill: "#29A063"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M173.916 121.57C173.916 121.57 159.876 138.66 152.856 147.21L106.266 119.11C114.736 112.09 123.206 105.07 131.666 98.0497C145.746 105.89 173.906 121.58 173.906 121.58L173.916 121.57Z",
    fill: "#72D09A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectricite);
export default __webpack_public_path__ + "static/media/electricite.13b83a9b969732f8e380069c5ea1b16d.svg";
export { ForwardRef as ReactComponent };